import { createContext } from 'react';

const CbmContext = createContext();

export default CbmContext;
